<!--
    Component is used from plugin. Check 'Confirm.plugin.js' for details.

    Component accepts string or VNode content. An array of VNodes is also acceptable.
-->

<template>
  <b-modal
    ref="confirmModal"
    modal-class="confirm-modal"
    centered
    hide-header-close
    :size="size"
    :title="title"
    @hidden="finishWorking" >
    <!-- No user input is rendered here. -->
    <!-- For rewrite check vue-sanitize and sanitize-html -->
    <!-- eslint-disable vue/no-v-html  -->
    <template v-if="Array.isArray(message)">
      <Vnodes
        v-for="(m, index) in message"
        :key="index"
        :vnodes="m"/>
    </template>
    <template v-else-if="message.constructor.name === 'VNode'">
      <Vnodes :vnodes="message"/>
    </template>
    <p
      v-else
      v-html="message" />
    <template slot="modal-footer">
      <div class="modal-footer__message">
        <div
          v-if="showUndoWarning"
          class="modal-footer__undo-warning flex flex-align-center">
          <span class="sb2-icon icon-error size-12"/>This action cannot be undone.
        </div>
      </div>
      <div class="modal-footer__buttons flex flex-row flex-nowrap">
        <b-button @click="hide">{{ cancelButtonText }}</b-button>
        <b-button
          v-if="hasCallback"
          :variant="buttonVariant"
          :class="{loading: working}"
          @click="confirm" >
          <span>{{ confirmButtonText }}</span>
          <Spinner
            v-if="working"
            :size="14"
            :thickness="2"
            :color="SBColors.white" />
        </b-button>
      </div>

    </template>
  </b-modal>
</template>

<script>

import Spinner from '@/components/common/Spinner';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'ConfirmModalComponent',
  components: {
    Spinner,
    // TODO for v2 rewrite consider creating a standalone helper component from this so it can be reusable
    Vnodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      defaultTitle: 'Confirm action',
      defaultSize: '',
      hasCallback: false,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      title: '',
      message: '',
      buttonVariant: 'primary',
      size: '',
      showUndoWarning: false,
      autoClose: true, // TODO this needs to be fixed to accept true, false. For now just write NO or something.
      working: false,
      onConfirmCallback() {},
      SBColors,
    };
  },
  beforeMount() {
    this.$infoModalEventBus.$on('show-confirm-modal', (params) => {
      this.show(params);
    });
    this.$infoModalEventBus.$on('close-confirm-modal', () => {
      this.hide();
    });
    this.$infoModalEventBus.$on('finish-working-confirm-modal', () => {
      this.finishWorking();
    });
  },
  methods: {
    /**
     * Shows the modal to the user.
     *
     * @param params Object which expects title(optional), message, size(optional), confirmCallback, type(optional), confirmButtonText(optional) and cancelButtonText(optional) keys to be available.
     */
    show(params) {
      this.title = params.title || this.defaultTitle;
      this.message = params.message;
      // TODO this is not implemented since there is no such case in the design yet. Will leave it here for a reminder.
      if (typeof params.confirmCallback === 'function') {
        this.hasCallback = true;
        this.onConfirmCallback = params.confirmCallback;
      }
      if (params.buttonVariant === 'RED') {
        this.buttonVariant = 'danger';
      } else {
        this.buttonVariant = 'primary';
      }
      this.showUndoWarning = params.showUndoWarning || false;
      this.confirmButtonText = params.confirmButtonText || this.confirmButtonText;
      this.cancelButtonText = params.cancelButtonText || this.cancelButtonText;
      this.autoClose = params.autoClose || true;
      this.$refs.confirmModal.show();
    },
    hide() {
      this.$refs.confirmModal.hide();
    },
    finishWorking() {
      this.working = false;
    },
    confirm() {
      this.onConfirmCallback();
      if (this.autoClose === true) {
        this.hide();
      } else {
        this.working = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .confirm-modal {
  .modal-content {
    .modal-header {
      padding: 20px;
      box-shadow: none;
      border-bottom: solid 1px $greyBorderModal;

      .modal-title {
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        color: $blackPrimary;
      }
    }
    .modal-body {
      padding: 20px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      color: $blackPrimary;
      background-color: $greyUltralight;
    }
    .modal-footer {
      border-top: solid 1px $greyBorderModal;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
    }
    .modal-footer>* {
      margin: 0;
    }
    .modal-footer__message {
      // style if needed
    }
    .modal-footer__buttons {
      // style if needed
      .btn.loading {
        position: relative;

        span {
          visibility: hidden;
        }

        .loader {
          position: absolute;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
    .modal-footer__undo-warning {
      color: $redPrimary;
      font-size: 14px;
      font-weight: 400;
      // icon 4px from text
      .sb2-icon {
        margin-right: 4px;
      }
    }
  }
}
</style>
